import { render, staticRenderFns } from "./SmsLogList.vue?vue&type=template&id=db133724&scoped=true&"
import script from "./SmsLogList.vue?vue&type=script&lang=js&"
export * from "./SmsLogList.vue?vue&type=script&lang=js&"
import style0 from "./SmsLogList.vue?vue&type=style&index=0&id=db133724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db133724",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VContainer,VIcon,VRow})
